import React, { useState } from 'react';
import { DatePicker, Row, Col } from 'antd';
import moment from 'moment';
import SeoScoreProgressCard from './SeoScoreProgressCard';
import ArchivedReportOverviewsCard from './ArchivedReportOverviewsCard';
import useGetCurrentWebsite from '../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';


const { MonthPicker } = DatePicker;

const validDateIntervalStart = moment('2019-01-01T00:00:00');

function checkIfDateIsDisabled(date: moment.Moment | null) {
    return (!!date && date < validDateIntervalStart) || (!!date && date > moment().endOf('day'));
}


export default function ReportOverviews() {
    const [startDate, setStartDate] = useState(() => moment().startOf('month'));
    const [endDate, setEndDate] = useState(() => moment().endOf('month'));
    const { website } = useGetCurrentWebsite();
    const websiteUrl = website?.homepage_url || '';
    const competitors = website?.settings.competitors || [];

    const handleIntervalChange = (date: moment.Moment | null) => {
        if (date) {
            // New selected date is already at start of month
            const newStartDate = moment(date);
            const newEndDate = moment(date).endOf('month');

            setStartDate(newStartDate);
            setEndDate(newEndDate);
        }
    };

    return (
        <div className="archived-reports-overview">
            <MonthPicker
                value={startDate}
                placeholder="Select month"
                format="MMMM YYYY"
                allowClear={false}
                disabledDate={checkIfDateIsDisabled}
                onChange={handleIntervalChange}
            />
            <div className="dashboard-skeleton-card-container analysis-page">
                <Row
                    gutter={20}
                    className="analysis-overview-container"
                >
                    <Col span={12}>
                        <SeoScoreProgressCard
                            websiteUrl={websiteUrl}
                            competitors={competitors}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </Col>
                    <Col span={12}>
                        <ArchivedReportOverviewsCard
                            websiteUrl={websiteUrl}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
